import AxiosInterceptor from "../../AxiosInterceptorAlcohol";

// 주별 질문 답변 리스트 조회
// request data
//  - weekNum : 주차
//  - pid
export function getEducationQuestionWeekFromAlcohol({weekNum, pid}) {
    return AxiosInterceptor({
        url: `/question/week/${weekNum}/${pid}`,
        method: 'get'
    })
}

// 음주 습관 변화도 입력 내역 리스트 조회
// request data
//  - pid
export function getQuestionHabitFromAlcohol({ pid }) {
    return AxiosInterceptor({
        url: `/question/habit/${pid}`,
        method: 'get'
    })
}


// 질문 정보 조회
// request data
//  - questionId
//  - pid
export function getQuestionFromAlcohol({questionId, pid}){
    return AxiosInterceptor({
        url: `/question/${questionId}/${pid}`,
        method: 'get'
    })
}


// 음주거절 효능감 타입 정보 조회
// request data
//  - pid
export function getDrinkRejectionFromAlcohol({questionId, pid}) {
    return AxiosInterceptor({
        url: `/question/rejection/type/${questionId}/${pid}`,
        method: 'get'
    })
}